var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5019 9C21.1588 9 22.5019 7.65686 22.5019 6C22.5019 4.34314 21.1588 3 19.5019 3C17.8452 3 16.5019 4.34314 16.5019 6C16.5019 7.65686 17.8452 9 19.5019 9ZM16.5811 9.90835C17.0781 9.65988 17.6718 9.70646 18.1239 10.0294L19.6239 11.1008C20.101 11.4417 20.3358 12.0294 20.2249 12.6052L18.6517 20.7705L25.2501 30.6679C25.7095 31.3572 25.5234 32.2885 24.834 32.7481C24.1447 33.2076 23.2134 33.0213 22.7539 32.3321L15.8143 21.9228L14.5911 20.0879C14.377 19.7667 14.2949 19.3753 14.362 18.9951L15.2568 13.9246L12.5789 15.2635L11.7211 19.5501C11.5586 20.3625 10.7683 20.8891 9.95597 20.7267C9.14365 20.5641 8.61691 19.7738 8.77945 18.9615L9.78112 13.9557C9.87193 13.5018 10.1672 13.1153 10.5811 12.9084L16.5811 9.90835ZM25.0276 19.423L20.7159 17.9858L21.2883 15.0144L25.9764 16.577C26.7622 16.839 27.187 17.6885 26.925 18.4743C26.6631 19.2603 25.8136 19.6851 25.0276 19.423ZM9.19457 30.7646L14.0965 22.0501L14.5663 22.7549L15.9634 24.8503L11.8093 32.2354C11.4032 32.9574 10.4886 33.2134 9.76655 32.8074C9.04451 32.4012 8.78843 31.4867 9.19457 30.7646Z",
    fill: "#0A2E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.64a65f63535ff3f664f376624e069f28.svg";
export { ForwardRef as ReactComponent };